import { useSelector } from "react-redux";
import { selectFooterSectionImages } from "state/selectors/Selectors";
import { getEnvironment } from "utils/utils";

const FooterSectionImages = () => {
  const env = getEnvironment();
  const footerSectionImages = useSelector(selectFooterSectionImages);

  const sortedFooterImages = [...footerSectionImages].sort((a, b) => {
    const aOrder = Number(a?.ImageOrder ?? 0);
    const bOrder = Number(b?.ImageOrder ?? 0);
    return aOrder - bOrder;
  });

  return (
    <>
      {sortedFooterImages.map((footerImage) => (
        <div
          key={footerImage.Id}
          className="!flex justify-end !w-full !mb-8 col-xs-12"
        >
          <div className="!w-full">
            <div className="relative !w-full overflow-hidden group transition-transform duration-500 hover:scale-105">
              <img
                src={`${env.imageUrl}/${footerImage.Image}`}
                alt={footerImage.Title}
                className="!w-full !h-[230px] !object-cover"
              />
              <div className="absolute inset-0 bg-black/50 transition-opacity duration-300 group-hover:opacity-0"></div>
              <a
                href={footerImage.Link}
                className="absolute inset-0 flex flex-col items-start justify-end !p-4 !no-underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                <h6 className="uppercase text-base !text-white !ml-0 text-wrap ">
                  {footerImage.Title}
                </h6>
                <p className="!text-white !mb-0">{footerImage.Description}</p>
              </a>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};
export default FooterSectionImages;
